module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Color-profile-11f72c8f12853bb049eff8b179fcc3c4.svg";